exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-table .cell[data-v-6a376f6e]{white-space:pre-wrap}", "", {"version":3,"sources":["/workspace/src/views/order/pages/OrderArchivedTable.vue"],"names":[],"mappings":"AACA,iCAAiC,oBAAoB,CACpD","file":"OrderArchivedTable.vue","sourcesContent":["\n.el-table .cell[data-v-6a376f6e]{white-space:pre-wrap\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a376f6e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/pages/OrderArchivedTable.vue
// module id = 4812
// module chunks = 11